"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1601))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:17.993Z
 * @optimized using svgo:^3.0.2
 */
export const PartyPopper = createSVGIcon(
  <>
    <path
      d="m3.682 22.629 11.452-4.257a2.153 2.153 0 0 0 .831-3.516l-7.2-7.2a2.153 2.153 0 0 0-3.516.831L.993 19.94a2.074 2.074 0 0 0 2.69 2.69ZM20.486 12.218a3.6 3.6 0 0 0-2.505-.357M16.582 7.335a3.6 3.6 0 0 0 .515-2.477M12.641 1.236a8.07 8.07 0 0 1-.233 5.674"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.143 5.621a.857.857 0 1 1-1.715 0 .857.857 0 0 1 1.715 0Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "PartyPopper",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
